import * as yup from 'yup';
import { getPhoneNumberRegex } from 'utils/phoneNumberValidation';

const countryCode = process.env.GATSBY_COUNTRY_CODE;

const NAME_REGEX_PATTERN = /^([^0-9]*)$/;

export const formSchema = (messages, country = { country: { countryCode } }) =>
  yup.object().shape({
    firstName: yup
      .string()
      .matches(NAME_REGEX_PATTERN, messages.firstName.invalid)
      .required(messages.firstName.required),
    lastName: yup.string().matches(NAME_REGEX_PATTERN, messages.lastName.invalid).required(messages.lastName.required),
    email: yup.string().email(messages.email.invalid).required(messages.email.required),
    phoneNumber: yup
      .string()
      .matches(getPhoneNumberRegex(country), messages.phoneNumber.invalid)
      .required(messages.phoneNumber.required),
    ageConsent: yup.boolean().oneOf([true], messages.ageConsent.required).required(),
    marketingConsent: yup.boolean(),
    additionalInfo: yup.string().when('$enableAdditionalInfo', {
      is: true,
      then: () => yup.string().required(messages.additionalInfo.required),
    }),
    city: yup.string().when('$enableCitiesDropdownList', {
      is: true,
      then: () => yup.string().required(messages.city.required),
    }),
  });

export default formSchema;
